import { useDesignSystem } from 'contexts/design-system'
import EmailInputEui from './emailInput.eui'
import EmailInputMui from './emailInput.mui'
import { EmailInputProps } from './types'

export type { EmailInputProps } from './types'

/**
 * Shared email input. Renders the EUI or MUI presentation based on the host
 * form's design system (`DesignSystemProvider`, default `'eui'`); label and
 * error presentation come from the shared `FormRow`, so both branches
 * validate identically. Public props and behavior are unchanged.
 */
export default function EmailInput( props: EmailInputProps ) {
	return useDesignSystem() === 'mui'
		? <EmailInputMui {...props} />
		: <EmailInputEui {...props} />
}
